export default __webpack_public_path__ + "static/media/devshop.ccff8aa6.svg";